// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Logs_BuscarLogsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /logs/buscar_logs endpoint
 *
 * Returns a list of application logs for display.
 *
 * Each item mirrors the `logs` table:
 * - log_id: Log primary key
 * - created_at: UTC timestamp the log entry was written (DATETIME, ISO 8601 UTC string)
 * - user_id: Cognito sub of the actor, or null/'system' for unauthenticated webhooks
 * - user_name: Display name of the actor (or 'System (Webhook)')
 * - message: Short human-readable label
 * - data: JSON-encoded payload (string — consumers parse on read)
 *
 * @see Logs_model::list() for the source query
 */
import type { Logs_BuscarLogsRow } from './Logs_BuscarLogsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Logs_BuscarLogsResponseDados {
logs: Logs_BuscarLogsRow[]
total: number
truncated: boolean
}

export type Logs_BuscarLogsResponse = ApiResponse<Logs_BuscarLogsResponseDados>;

registerResponseContract('Logs_BuscarLogsResponse', {
  logs: {
    type: 'array',
    required: true,
    items: {
      log_id:     { type: 'number',  required: true },
      created_at: { type: 'string',  required: false },
      user_id:    { type: 'string',  required: false },
      user_name:  { type: 'string',  required: true },
      message:    { type: 'string',  required: true },
      data:       { type: 'string',  required: true },
    },
  },
  total:     { type: 'number',  required: true },
  truncated: { type: 'boolean', required: true },
})
